<template>
    <div v-if="mobile" id="myNav" class="overlay overlay-without-header">
         <form autocomplete="off" novalidate method="POST" class="mainForm" action="/search">
             <input autocomplete="false" type="hidden" class="hidden-field" :value="currentsearch ? currentsearch.categoria : null" name="categoria" required />
             <input autocomplete="false" type="hidden" ref="geojsonmobile" name="geojson" id="geojsonmobile"/>
             <input type="hidden" name="sort_order" :value="currentsearch ? currentsearch.order : ''">
             <input type="hidden" name="sort_direction" :value="currentsearch ? currentsearch.direction : ''">
        <a href="javascript:void(0)" class="closebtn" onclick="closeNav()">&times;</a>
        <div class="overlay-content">
            <div class="col-lg-4 col-md-12">
                <div class="sidebar-right">

                        <div class="form-group">
                            <ul class="strong">
                                <strong class="color-smart">Cosa stai cercando?</strong>
                            </ul>
                            <category-select
                                :title="show_label ? 'Categoria' : ''"
                                :labelcolor="colors.secondary"
                                :primarycolor="colors.primary"
                                style="flex: 1 1 auto;"
                                :options="formdata.categorie"
                                name="categoria"
                                trackby="id"
                                id="categoriaMobile"
                                :required="true"
                                :allowEmpty="false"
                                @onChange="setInput('categoria', $event, $emit('get-tipologie', $event))"
                                :currentvalue="selectedValue.categoria"
                                selectname="categoria"
                                placeholder="Seleziona..."
                                :style="$v.formInputs.categoria.$error ? 'color:'+colors.primary+';border: '+colors.primary+' 1.2px solid;' : ''"
                            ></category-select>
                            <div :style="'color:'+colors.primary" v-show="$v.formInputs.categoria.$error">Il campo Categoria è richiesto!</div>
                        </div>
                        <div class="form-group">
                            <ul class="strong">
                                <strong class="color-smart">Contratto </strong>
                            </ul>
                             <category-select
                                :label="show_label ? 'Contratto' : ''"
                                :labelcolor="colors.secondary"
                                :primarycolor="colors.primary"
                                style="flex: 1 1 auto;"
                                :options="formdata.contratti"
                                name="contratto"
                                trackby="id"
                                :required="true"
                                :allowEmpty="false"
                                @onChange="setInput('contratto', $event, $emit('update-prezzi', $event))"
                                :currentvalue="selectedValue.contratto"
                                selectname="contratto"
                                placeholder="Seleziona..."
                                :style="$v.formInputs.contratto.$error ? 'color:'+colors.primary+';border: '+colors.primary+' 1.2px solid;' : ''"
                             ></category-select>
                            <div :style="'color:'+colors.primary" v-show="$v.formInputs.contratto.$error">Il campo Contratto è richiesto!</div>

                        </div>
                        <div class="form-group">
                            <ul class="strong">
                                <strong class="color-smart"> Tipologia </strong>
                            </ul>
                             <category-select
                                :label="show_label ? 'Tipologie' : ''"
                                :labelcolor="colors.secondary"
                                :primarycolor="colors.primary"
                                style="flex: 1 1 auto;"
                                :options="formdata.tipologie"
                                name="tipologie"
                                trackby="id"
                                :closeonselect="false"
                                :currentvalue="selectedValue.tipologie"
                                :multiple="true"
                                selectname="tipologie"
                                placeholder="Seleziona..."
                                selection_name="tipologie"
                                @onChange="setInput('tipologie', $event, $emit('cambio-tipologie', $event))"
                                :style="$v.formInputs.tipologie.$error ? 'color:'+colors.primary+';border: '+colors.primary+' 1.2px solid;' : ''"
                             ></category-select>
                            <div  :style="'color:'+colors.primary" v-show="$v.formInputs.tipologie.$error">Il campo Tipologia è richiesto!</div>
                        </div>
                         <ul class="strong">
                            <strong class="color-smart"> Comune o zona </strong>
                        </ul>
                        <div class="form-group">
                            <zone-select
                                :label="show_label ? 'Zone' : ''"
                                :labelcolor="colors.secondary"
                                :primarycolor="colors.primary"
                                name="zone"
                                style="flex: 1 1 auto;"
                                selectname="zone"
                                trackby="id"
                                :disabled="zoneIsDisabled()"
                                @clear-value="clearZone"
                                :currentvalue="selectedValue.zone"
                                :options="formdata.zone"
                                placeholder="Comune o zona"
                                @onChange="setInput('zone', $event)"
                                :style="zoneRequired ? 'color:'+colors.primary+';border: '+colors.primary+' 1.2px solid;' : ''"
                            ></zone-select>

                            <div :style="'color:'+colors.primary" v-show="$v.formInputs.zone.$error">Il campo Comune o zona è richiesto!</div>
                        </div>
                        <div class="form-group">
                            <div class="mapSearchBtn" v-if="!$root.mapselected">
                                <button class="btn-brr btn-secondary-sm draw-mobile-btn" type="button" @click="() =>{ $emit('showmap'); formInputs.zone = []; }">
                                    <i class="fa fa-map"></i> Disegna area
                                </button>
                            </div>
                            <div class="mapSearchBtn" v-if="$root.mapselected">
                                <button class="btn-brr btn-secondary-sm draw-mobile-btn" type="button" @click="() => { $emit('removeselection'); formInputs.geojson = null; }">
                                    <i class="fa fa-map"></i> Rimuovi selezione mappa
                                </button>
                            </div>
                        </div>
                        <ul class="strong">
                            <strong class="color-smart"> Prezzo </strong>
                        </ul>
                        <div class="row">
                            <div class="col-6 form-group form-inline">
                                <div class="input-group">
                                    <span class="input-group-addon btn-brr btn-secondary-sm">da </span>
                                    <input name="min_price" @change="setInput('min_price', $event)" type="text" class="form-control" placeholder="Euro">
                                </div>
                            </div>
                            <div class="col-6 form-group form-inline">
                                <div class="input-group">
                                    <span class="input-group-addon btn-brr btn-secondary-sm">&nbsp; a </span>
                                    <input name="max_price" @change="setInput('max_price', $event)"  type="text" class="form-control" placeholder="Euro">
                                </div>
                            </div>
                        </div>

                        <template v-if="currentsearch">
                            <div class="row my-3">
                                <div class="col-12">
                                    <a class="text-primary font-weight-bold text-center" data-toggle="collapse" data-target="#options-content">ALTRI FILTRI</a>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <div id="options-content" class="collapse mb-3">
                                        <p><strong class="text-primary">*Ulteriori caratteristiche (indica solo quello che per te è fondamentale)</strong></p>
                                        <advanced-filters @setfiltroavanzato="setFiltroAvanzato" v-if="formdata.filtriAvanzati" columnclass="col-lg-3 col-md-3 col-sm-6" :labelcolor="colors.secondary" :primarycolor="colors.primary" :filtri="formdata.filtriAvanzati" :currentvalue="currentsearch ? currentsearch : null" id_text_prepend="mobile_" />
                                    </div>
                                </div>
                            </div>
                        </template>

                        <div class="form-group mb-0">
                            <button class="search-button" @click.prevent="submitData">Cerca</button>
                        </div>
                </div>
            </div>
        </div>
         </form>
    </div>
</template>

<script>

import {validationMixin} from "vuelidate";
import {required, requiredIf} from 'vuelidate/lib/validators'

export default {
    mixins: [validationMixin],
    props: {
        currentsearch: null,
        homepagedata: null,
        formdata: {},
        selectedValue: {},
        colors: {},
        mobile: false,
        contratti: null,
        tipologie: null,
        min_price: null,
        max_price: null,
        show_label: {
            type: Boolean,
            default: false
        },
        geojsonParent: '',
    },
    data () {
        return {
            zoneOptions: [],
            ricercaCorrente: [],
            formInputsAvanzati: this.currentsearch,
            formInputs: {
                contratto: null,
                tipologie: [],
                zone: [],
                categoria: null,
                min_price: null,
                max_price: null,
                geojson:null
            },
            zoneRequired : false,
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        }
    },
    validations() {
        return {
            formInputs: {
                categoria: {required},
                tipologie: {required},
                contratto: {required},
                zone: {
                    required: requiredIf(function(model) {
                        return ! model.geojson;
                    })
                },
            }
        }
    },
    mounted() {
        if (this.currentsearch) {

            Object.entries(this.currentsearch).forEach(([k,v]) => {
                if (this.formInputs.hasOwnProperty(k)){
                    this.$set(this.formInputs, k, v);
                }
            })
        }

    },
    methods: {
        clearZone() {
            this.zoneOptions = this.homepagedata.zone;
            this.formInputs.zone = [];
        },
        zoneIsDisabled() {
            return this.$root.mapselected ? true : false;
        },
        setInput(tipo, event, emit=null){
             if (event) {
                 if (tipo==='categoria'){
                     this.formInputs.contratto = null;
                     this.formInputs.tipologie = [];
                     this.formInputs.min_price = null;
                     this.formInputs.max_price = null;
                     this.formInputsAvanzati = {};
                 }
                 if (event.target) {
                     this.$set(this.formInputs, tipo, event.target.value);
                 } else {
                     if (Array.isArray(event)){
                         let arrayOfIds = [];
                         arrayOfIds = event.map(x =>
                             x.id)
                         this.$set(this.formInputs, tipo, arrayOfIds);
                     }
                     else {
                         this.$set(this.formInputs, tipo, event.id);
                     }
                 }
             }
        },
        setFiltroAvanzato(event) {
            // A seconda del tipo di filtro vado a popolare i miei filtri avanzati
            switch(event.type) {
                case 'select':
                    if(event.multiple){
                        // Se la select è multipla devo prendere tutti gli oggetti scelti e costruire un array di id
                        let values = [];
                        event.value.forEach(element => {
                            values.push(element.id);
                        });
                        this.$set(this.formInputsAvanzati, event.name, values);
                    }
                    else{
                        // Se la select è singola vado semplicemente a popolare il valore nell'oggetto
                        this.$set(this.formInputsAvanzati, event.name, event.value.id);
                    }
                break;
                case 'checkbox':
                    // Vado semplicemente a popolare il valore nell'oggetto
                    this.$set(this.formInputsAvanzati, event.name, event.value.target.checked);
                break;
            }
        },
        submitData(){

            let geojson = ($('#geojsonmobile').val()) ? $('#geojsonmobile').val() : $('#geojson_desktop').val() ;
            if (geojson){
                this.zoneRequired=false;
                this.$set(this.formInputs, 'geojson', JSON.parse(geojson));
            }

            this.$v.$touch();

            if(! this.$v.$invalid && !this.zoneRequired){

                window.axios.defaults.headers.common['X-CSRF-TOKEN'] = this.csrf;
                window.axios.post(process.env.MIX_BASE_URL+'ricerca/url-generate', {...this.formInputsAvanzati,...this.formInputs})
                    .then(res => {
                        window.location.href = res.data.data.url;
                    })
                    .catch(err => {
                        Swal.fire({
                            text: 'Ops! Qualcosa è andato storto, per favore prova di nuovo.',
                            type: 'error'
                        })
                    });
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .draw-mobile-btn {
        width: 100%;
        height: 40px;
    }
    .is-invalid {
        color: #dc3545;
        border: #dc3545 1.2px solid;
    }
</style>
